<template>
  <div ref="sl" class="keen-slider sl-slider">
    <slot></slot>
  </div>

  <!-- Slider Controllers -->
  <div class="mt-30 flex items-center justify-between gap-5 sm:hidden">
    <button
      @click="
        () => {
          sl.prev();
        }
      "
    >
      <svg
        width="16"
        height="27"
        viewBox="0 0 16 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_60_93)">
          <path
            d="M13.5193 25.4783L2.48083 13.5L13.5193 1.52168"
            stroke="#3F3F3F"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_60_93">
            <rect
              width="16"
              height="27"
              fill="white"
              transform="translate(16 27) rotate(-180)"
            />
          </clipPath>
        </defs>
      </svg>
    </button>

    <!-- dots -->
    <div class="flex w-full justify-center">
      <div v-if="sl" class="dots-gift flex flex-wrap justify-center gap-10">
        <button
          type="button"
          v-for="(_slide, idx) in dotHelper"
          @click="
            () => {
              sl.moveToIdx(idx);
            }
          "
          :class="{dot: true, active: current === idx}"
          :key="idx"
        ></button>
      </div>
    </div>

    <button
      @click="
        () => {
          sl.next();
        }
      "
    >
      <svg
        width="16"
        height="27"
        viewBox="0 0 16 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_60_91)">
          <path
            d="M2.48071 1.52173L13.5192 13.5L2.48071 25.4783"
            stroke="#3F3F3F"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_60_91">
            <rect width="16" height="27" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
</template>

<script>
import KeenSlider from "keen-slider";
import "keen-slider/keen-slider.min.css";

export default {
  name: "carousel-keen",
  props: {
    slides: {
      type: Number,
      default: 4,
    },
  },

  data() {
    return {
      current: 0,
      sl: null,
    };
  },
  computed: {
    dotHelper() {
      return this.sl
        ? [...Array(this.sl?.track?.details?.slides?.length).keys()]
        : [];
    },
  },
  methods: {
    initSlider() {
      setTimeout(() => {
        this.sl = new KeenSlider(this.$refs.sl, {
          loop: false,
          rtl: false,
          initial: this.current,
          slideChanged: s => {
            this.current = s.track.details.rel;
          },
          breakpoints: {
            "(max-width: 1024px)": {
              slides: {
                perView: 3,
                spacing: 10,
              },
            },
            "(max-width: 768px)": {
              slides: {
                perView: 1,
                spacing: 40,
              },
            },
          },
          slides: {
            perView: this.slides,
            spacing: 20,
          },
        });
      }, 1);
    },
  },
  mounted() {
    this.initSlider();
  },
};
</script>
